import axios from 'axios'
import {EntityDto} from '../../../services/dto/entityDto'
import CreateProfile from './dto/CreateProfile'
import UpdateProfile from './dto/UpdateProfile'
import GetProfile from './dto/GetProfile'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Profile/Create`
export const URL_DELETE = `${API_URL}/Profile/Delete`
export const URL_GET = `${API_URL}/Profile/GetUserDetail`
export const URL_GET_BY_ID = `${API_URL}/Profile/GetUserDetailByUserId`
export const URL_UPDATE = `${API_URL}/Profile/Update`

export function onCreateProfile(createProfile: CreateProfile): Promise<boolean> {
  return axios.post(URL_CREATE, createProfile)
}

export function onDeleteProfile(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetProfile(): Promise<GetProfile> {
  return axios.get(URL_GET)
}

export function onGetProfileByUserId(entityDto: EntityDto): Promise<GetProfile> {
  return axios.get(URL_GET_BY_ID, {params: entityDto})
}

export function onUpdateProfile(updateProfileInput: UpdateProfile): Promise<boolean> {
  return axios.put(URL_UPDATE, updateProfileInput)
}
